import { Association } from './association';
import { Reason } from './reason';

export class AssociationStatusUtils {
  static buildVisitedAssociationStatuses(
    selectedAssociation: Association,
    existingAssociationStatuses: AssociationStatus[],
    reasons: Reason[] = null,
  ): AssociationStatus[] {
    existingAssociationStatuses.push({
      status: selectedAssociation.status,
      createdByName: ASSOCIATION_STATUS_CREATED_BY_NAME_IRP,
      lastModifiedByName: ASSOCIATION_STATUS_CREATED_BY_NAME_IRP,
      subStatus: selectedAssociation.subStatus,
      comment: selectedAssociation.noteComment,
      reasons,
    });
    return existingAssociationStatuses;
  }

  static extractQuantityFromString(statusWithQuantity: string) {
    return statusWithQuantity.replace(/ \(.*?\)/g, '');
  }
}

export class AssociationStatus {
  status: string;
  createdByName: string;
  lastModifiedByName: string;
  lastModifiedDate?: Date;
  createdDate?: Date;
  subStatus: string;
  comment: string;
  reasons: Reason[];
}
export const ALL_SELECTED = 'All statuses';
export const ASSOCIATION_STATUS_CREATED_BY_NAME_IRP = 'IRP';
